module.exports = __webpack_public_path__ + "img/face-border2.21036adc.svg";